import * as React from "react";

import LastMessage from "../LastMessage";

import { IChatNormalized } from "../../../types/index";
import Avatar from "../../Avatar";

const s = require("./ChatListItem.scss");

interface IChatListItemProps {
    chat: IChatNormalized;
    onClick: (e: React.MouseEvent<HTMLDivElement>, id: string) => void;
    active: boolean;
};

interface IChatListItemState {};

class ChatListItem extends React.Component<IChatListItemProps, IChatListItemState> {
    public render(): JSX.Element {
        const chat = this.props.chat;
        const avatar = (chat.is_group ? 
            (chat.avatar ? chat.avatar.small_url : null) :
            (chat.user.avatar ? chat.user.avatar.small_url : null)
        );

        return (
            <div className={s.chatItem + (this.props.active ? " " + s.active : "")} onClick={event => this.props.onClick(event, this.props.chat.id)}>
                <div className={s.content}>
                    <div className={s.avatar}>
                        <Avatar 
                            size="small"
                            image={avatar}
                            group={this.props.chat.is_group}
                        />
                    </div>
                    <div className={s.info}>
                        <div className={s.userName}>{this.props.chat.name}</div>
                        <LastMessage message={this.props.chat.lastMessage}/>
                        {(this.props.chat.unread_count > 0 ? (
                            <div className={s.unreadCounter}><span>{this.props.chat.unread_count}</span></div>
                        ) : null)}
                    </div>
                </div>
            </div>
        );
    }
}

export default ChatListItem;



// WEBPACK FOOTER //
// ./src/components/ChatList/Item/index.tsx